export const payFrequencyLabels: Record<number, string> = { 1: 'Weekly', 2: 'Biweekly', 3: 'Semimonthly', 4: 'Monthly', 5: 'Quarterly' };
export const earningTaxTypeLabels: Record<number, string> = { 1: 'Taxable', 2: 'Pre-tax deferred', 3: 'Non-taxable' };
export const deductionTaxTypeLabels: Record<number, string> = { 1: 'Pre-tax', 2: 'Post-tax' };
export const deductionAmountTypeLabels: Record<number, string> = { 1: 'Flat amount', 2: 'Percentage' };

export interface PayScheduleResponse {
  id: string;
  name: string;
  frequency: number;
  /** Null when the pay day is the last day of the month (firstPayDayKind 2). */
  firstPayDay: number | null;
  secondPayDay: number | null;
  /** EPN-192: returned by the server; 1 = a numbered day of the month, 2 = the last day of the month. */
  firstPayDayKind?: number;
  secondPayDayKind?: number | null;
  payPeriodStartDate?: string | null;
  isDefault: boolean;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string | null;
}

export interface PayScheduleInput {
  name: string;
  frequency: number;
  firstPayDay: number | null;
  secondPayDay: number | null;
  /** 1 = numbered day of the month, 2 = last day of the month (day sent as null). Omitted = numbered day / weekday. */
  firstPayDayKind?: number;
  secondPayDayKind?: number | null;
  /** EPN-216: the start of the pay period the schedule counts from. The server already accepts it on create and update. */
  payPeriodStartDate?: string | null;
}

export interface EarningCodeResponse {
  id: string;
  name: string;
  taxType: number;
  w2Code: string | null;
  exemptFederal: boolean | null;
  exemptFica: boolean | null;
  exemptState: boolean | null;
  glAccountDefault: string | null;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string | null;
}

export interface EarningCodeInput {
  name: string;
  taxType: number;
  w2Code: string | null;
  exemptFederal: boolean | null;
  exemptFica: boolean | null;
  exemptState: boolean | null;
  glAccountDefault: string | null;
}

export interface DeductionCodeResponse {
  id: string;
  name: string;
  taxType: number;
  amountType: number;
  defaultAmount: number | null;
  defaultCompanyContribution: number | null;
  w2Code: string | null;
  exemptFederal: boolean | null;
  exemptFica: boolean | null;
  exemptState: boolean | null;
  glAccountDefault: string | null;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string | null;
}

export const workRatePayTypeLabels: Record<number, string> = {
  1: 'Hourly', 2: 'Salary', 3: 'Commission', 4: 'Tips', 5: 'Executive bonus',
};
export const workRateAmountBasisLabels: Record<number, string> = { 1: 'Per hour', 2: 'Per pay period', 3: 'Annual' };

/** A reusable, company-level rate template owned by EPN.PayrollConfig.Api (/api/work-rates). */
export interface WorkRateResponse {
  id: string;
  jobTitleId: string | null;
  label: string;
  payType: number;
  amount: number;
  amountBasis: number;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string | null;
}

export interface WorkRateInput {
  jobTitleId: string | null;
  label: string;
  payType: number;
  amount: number;
  amountBasis: number;
}

export interface DeductionCodeInput {
  name: string;
  taxType: number;
  amountType: number;
  defaultAmount: number | null;
  defaultCompanyContribution: number | null;
  w2Code: string | null;
  exemptFederal: boolean | null;
  exemptFica: boolean | null;
  exemptState: boolean | null;
  glAccountDefault: string | null;
  /** Omitted means active. false records a definition payroll has not reviewed yet, so the calculation skips it until it is activated. */
  isActive?: boolean;
}
